;(function() {
/* @ngInject */
function PlatbaPrevodomController(IndexService, PaymentService, $rootScope, $window, routes) {

    let vm = this;
    let server = IndexService;
    let paymentService = PaymentService;

    vm.setStatsTB = setStatsTB;

    vm.payment = {};
    vm.isLegalia = false;

    window.showSpinner(1);
    server.getPaymentAdnQrCode().then(onPaymentAndQrCodeLoad);

    function onPaymentAndQrCodeLoad(item) {
        if (item && item.vs) {
            vm.isLegalia = item.businessServicesDodavatelId === "Legalia";

            if (vm.isLegalia) {
                paymentService.getLegaliaBankTransferData(item.hash)
                  .then((paymentData) => onPaymentLoad(paymentData, item));
                return;
            }

            onPaymentLoad(item, item);
        } else {
            $window.location = routes.index;
        }
    }

    function onPaymentLoad(paymentData, orderData) {
        if (!paymentData) {
            $window.location = routes.index;
            return;
        }

        vm.payment = paymentData;
        $rootScope.$broadcast('service-load', {orderType: orderData.orderType, isSingle: orderData.isSingle});
        window.hideSpinnerWhenAllResolved();
    }

    function setStatsTB() {
        server.setStats({
            url: "https://www.moja.firmaren.sk/zlavy-a-akcie/tatrabanka",
            source: "Firmaren-Prevodom",
            medium: "Tatrabanka",
            campaign: "Button"
        }).then();
    }

}

angular.module("firmaren")
    .controller("PlatbaPrevodomController", PlatbaPrevodomController);
}());
